import { useIsGarageAdmin, useIsPortal } from 'utils/Subscription/PermissionSelector'
import { ShopCountry } from '@cbgms/base/shop-id'
import { useGetCountryForPolicyURLS } from './use-get-country-for-policy'
import { useIsAuthenticated } from 'hooks/use-is-authenticated'
import useApplicationName from './use-application-name'

interface IUrlsPerCountry {
  [ShopCountry.GB]: string
  [ShopCountry.NL]: string
  [ShopCountry.BE]: string
  [ShopCountry.DE]: string
  [ShopCountry.FR]: string
}

interface IUrls {
  portal: IUrlsPerCountry
  gms: IUrlsPerCountry
  garageAdmin: IUrlsPerCountry
}

const urls: IUrls = {
  portal: {
    GB: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/portal/Privacy.Policy.Websites.UK.pdf',
    NL: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/portal/Privacy.Policy.Websites.NL.pdf',
    BE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/portal/Privacy.Policy.Websites.BE.pdf',
    DE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/portal/Privacy.Policy.Websites.DE.pdf',
    FR: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/portal/Privacy.Policy.Websites.FR.pdf'
  },
  gms: {
    GB: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/gms/Privacy.Policy.Websites.UK.pdf',
    NL: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/gms/Privacy.Policy.Websites.NL.pdf',
    BE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/gms/Privacy.Policy.Websites.BE.pdf',
    DE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/gms/Privacy.Policy.Websites.DE.pdf',
    FR: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/gms/Privacy.Policy.Websites.FR.pdf'
  },
  garageAdmin: {
    GB: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/garageadmin/Privacy.Policy.Websites.UK.pdf',
    NL: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/garageadmin/Privacy.Policy.Websites.NL.pdf',
    BE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/garageadmin/Privacy.Policy.Websites.BE.pdf',
    DE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/garageadmin/Privacy.Policy.Websites.DE.pdf',
    FR: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/privacy-policy/garageadmin/Privacy.Policy.Websites.FR.pdf'
  }
}

export const useGetPrivacyPolicyUrl = () => {
  const applicationName = useApplicationName()
  const authenticated = useIsAuthenticated()
  const isPortal = useIsPortal()
  const isGarageAdmin = useIsGarageAdmin()
  const c = useGetCountryForPolicyURLS()

  if (!authenticated) {
    switch (applicationName) {
      case 'carcat':
        return urls.portal[c]
      case 'carsys':
        return urls.gms[c]
    }
  }

  if (isPortal) return urls.portal[c]
  if (isGarageAdmin) return urls.garageAdmin[c]
  return urls.gms[c]
}
